import SuperadminLayout from '../../components/SuperadminLayout';
import SuperadminLoginBgCard from './SuperadminLoginBgCard';

// Superadmin → Sistem → Giriş ekranı fon şəkli: öz şəkli olmayan restoranlar üçün default fon.
export default function LoginBackground() {
    return (
        <SuperadminLayout title="Giriş ekranı fon şəkli" subtitle="Öz şəkli seçilməmiş restoranların giriş ekranı">
            <div className="max-w-3xl">
                <SuperadminLoginBgCard />
            </div>
        </SuperadminLayout>
    );
}
